import axios from 'axios';
import { BASE_URL } from './config';
import { LegalDocumentType } from '../models/LegalDocuments/legal-document-type.enum';
import PrivacyPolicyPdf from '../assets/documents/Privacy_Policy_v2-12-2023.pdf';
import TermsOfServicePdf from '../assets/documents/TERMS_OF_SERVICE_12.9.2025.pdf';
import BuyerTermsOfServicePdf from '../assets/documents/Buyer_Terms_of_Service_1-26-2026.pdf';

const PUBLIC_ENDPOINT_MAP: Record<LegalDocumentType, string> = {
    [LegalDocumentType.PrivacyPolicy]: '/api/public/legal-documents/privacy-policy',
    [LegalDocumentType.TermsOfService]: '/api/public/legal-documents/terms-of-service',
    [LegalDocumentType.BuyersTermsOfService]: '/api/public/legal-documents/buyers-terms-of-service',
};

const FALLBACK_PDF_MAP: Record<LegalDocumentType, string> = {
    [LegalDocumentType.PrivacyPolicy]: PrivacyPolicyPdf,
    [LegalDocumentType.TermsOfService]: TermsOfServicePdf,
    [LegalDocumentType.BuyersTermsOfService]: BuyerTermsOfServicePdf,
};

export const openLegalDocument = async (
    documentType: LegalDocumentType,
    authAxios?: any
): Promise<void> => {
    try {
        const endpoint = PUBLIC_ENDPOINT_MAP[documentType];
        let response;

        if (authAxios) {
            response = await authAxios.get(endpoint);
        } else {
            const baseUrl = BASE_URL === '/' ? '' : BASE_URL;
            response = await axios.get(`${baseUrl}${endpoint}`);
        }

        if (response.status === 200 && response.data) {
            const url = typeof response.data === 'string' 
                ? response.data 
                : (response.data.downloadUrl || response.data.url);
            
            if (url) {
                window.open(url, '_blank');
                return;
            }
        }
        
        window.open(FALLBACK_PDF_MAP[documentType], '_blank');
    } catch (error) {
        console.error('Error fetching legal document, using fallback:', error);
        window.open(FALLBACK_PDF_MAP[documentType], '_blank');
    }
};
